export default __webpack_public_path__ + "static/media/Foto33.7da9ae2c.png";